import Service from './Service'

class PriceLists extends Service {
  /**
   * @name PriceLists#productsInPriceList
   * @type {ProductsInPriceList}
   */

  constructor (connection, productsInPriceList) {
    super(connection)
    this.productsInPriceList = productsInPriceList
  }

  get (params) {
    params.request = 'getPriceLists'
    return this.fetchAllRecords('', params)
      .catch(response => this.handleErrorResponse(response))
      .then(priceLists => priceLists.map(priceList => {
        if (!priceList.pricelistRules) priceList.pricelistRules = []
        return priceList
      }))
  }

  getById (id) {
    return this.get({
      pricelistID: id
    })
      .then(priceLists => priceLists[0])
  }

  getByIds (ids) {
    if (ids.length === 0) {
      return Promise.resolve([])
    }

    return this.get({
      priceListIDs: ids.join(',')
    })
  }
}
export default PriceLists



// WEBPACK FOOTER //
// ./src/api/Service/PriceLists.js